module.exports = __webpack_public_path__ + "img/08-min.ee2619c6.jpg";